import * as signalR from "@microsoft/signalr";
import tokenStorage from "@cayo/shared/settings/tokenStorage";
import { endpoints } from "@cayo/shared/services/endpoints.service";

export const RECONNECT_TIMEOUT = 2000;

export const createSignalRConnection = () => {
  const getAccessToken = () => tokenStorage.accessToken || "";

  return new signalR.HubConnectionBuilder()
    .withUrl(`${endpoints.publicUrl}/hubs/notifications`, {
      accessTokenFactory: getAccessToken,
    })
    .configureLogging(signalR.LogLevel.Critical)
    .build();
};
